import { i18next } from '@yola/ws-sdk';
import elementSettings from 'src/js/modules/element-settings';
import ThisMediaAppearanceSettingsContainer from '../containers/this-media-appearance-settings-container';
import MediaSwitcherContainer from '../containers/media-switcher-container';
import { matchesImageMedia, getImageTargetElement } from '../helpers/matches-image-media';
import { matchesIframeMedia, getIframeTargetElement } from '../helpers/matches-iframe-media';
import getMediaTypeId from '../helpers/get-media-type-id';
import mediaTypeIds from '../constants/media-type-ids';
import selectors from '../constants/selectors';
import settingIds from '../constants/setting-ids';

const {
  constants: { triggerTypes },
} = elementSettings;

const getThisMediaSettings = () => ({
  id: settingIds.THIS_MEDIA,
  triggerOn: triggerTypes.SELECT,
  priority: 2,
  // eslint-disable-next-line no-unused-vars
  matches(element, config) {
    const type = getMediaTypeId(element);

    if (type === mediaTypeIds.IMAGE) {
      return matchesImageMedia(element);
    }

    if (type === mediaTypeIds.VIDEO) {
      return matchesIframeMedia(element);
    }

    return false;
  },
  // eslint-disable-next-line no-unused-vars
  getTargetElement(element, config) {
    const type = getMediaTypeId(element);

    if (type === mediaTypeIds.IMAGE) {
      return getImageTargetElement(element);
    }

    if (type === mediaTypeIds.VIDEO) {
      return getIframeTargetElement(element);
    }

    return element;
  },
  getTargetElementType(element, config) {
    return getMediaTypeId(element);
  },
  settings: {
    querySelector: selectors.MEDIA_CONTAINER,
  },
  tabs: [
    {
      id: 'settings',
      title: i18next.t('Media'),
      component: MediaSwitcherContainer,
    },
    {
      id: 'appearance',
      accordionTitle: i18next.t('This media'),
      component: ThisMediaAppearanceSettingsContainer,
    },
  ],
});

export default getThisMediaSettings;
